// Logs the error's name only: messages can quote DICOM UIDs or structure names, which are PHI.
export function logErrorName(context: string, error: unknown): void {
    console.error(context, error instanceof Error ? error.name : typeof error);
}
